
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import { getcplider, coinList, whList, getNoticeList, stockList,stockLarge, ptlogin} from '../service/getdata'
export default{
components:{
XHeader,
Toast,
swiper,
swiperSlide
},
data(){
return{
stockList: [],
sort: 1,
msg: "",
show: false,
tabIndex: 0,
leftVal: 0,
newsList: [],
coinList: [],
nation: "US",
timerInfo: null,
slides:[],
app_name: "",
swiperOption: {
pagination: {
el: '.swiper-pagination'
},
paginationClickable :true,
prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
scrollbar:'.swiper-scrollbar',
mousewheelControl : true,
observeParents:true,
slidesPerView: 1,
spaceBetween: 30,
autoplay: {
delay: 2000,//秒
stopOnLastSlide: false,
disableOnInteraction: false,//滑动不会失效
},
loop: true,
loopFillGroupWithBlank: true,
pagination: {
el: '.swiper-pagination',
clickable: true,
},
},
}
},
mounted(){


},
computed:{
...mapState(['userdetail','user','token','url'])
},
created(){
this.SETTOKEN()
this.tabIndex = window.localStorage.getItem('tabIndex') || 0
this.getBanner()
clearInterval(this.timerInfo)
this.timerInfo = null
this.getCoinList(true)
this.timerInfo = setInterval(() => {
if(this.coinList.length>0){
this.getCoinList()
}

}, 2000);
this.getNotice()
this.getAppName()

},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"SETUSERNAME"]),
getAppName(){
var that = this
ptlogin().then(function(res){
var res = res.data;
that.app_name = res.data.logan







}.bind(this),function(){
console.log("error")
})
},
goContract(type, trade_type){
console.log(trade_type)
console.log(this.coinList[0])
if(trade_type==1){
this.$router.push(`/pages/info?name=BTC&type=${type}&trade_type=1`)
}else if(trade_type==2){
this.$router.push(`/pages/info?name=${this.coinList[0].ptitle}&type=${type}&trade_type=2&pid=${this.coinList[0].id}&code=${this.coinList[0].ptitle}`)
}else{
this.$router.push(`/pages/info?name=APLE&type=${type}&trade_type=3&code=APLE&nation=${this.nation}`)
}

},
goSpot(){
if(this.tabIndex==1){
this.$router.push(`/pages/spot?name=${this.coinList[0].name}&code=${this.coinList[0].name}&trade_type=3&nation=${this.nation}&flag=${this.coinList[0].flag}`)
}else{
this.$router.push(`/pages/spot?name=APLE&code=APLE&trade_type=3&nation=${this.nation}&flag=${this.coinList[0].flag}`)
}
},
goUrl(url){
if(!!url && url!=''){
this.$router.push(`/pages/rechargeIframe?url=${encodeURI(url)}`)
}
},
getBanner(){
var that = this
getcplider({equipment: 2}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.slides = res.data
console.log(that.slides)
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
console.log("error")
})
},
getNotice(){
var that = this
getNoticeList().then(function(res){
var res = res.data;
if(res.status=='1'){
that.newsList=res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
console.log("error")
})
},
getCoinList(isLoading){
if(isLoading){
this.coinList =[]
this.$Loading()
}

var that = this
if(this.tabIndex==0){
coinList({token: this.token, type: this.sort}).then(function(res){
var res = res.data;
if(isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.coinList = res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(isLoading){
that.$Loading.close()
}
console.log("error")
})
}else if(this.tabIndex==1){
whList({token: this.token, type: this.sort}).then(function(res){
var res = res.data;
if(isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.coinList = res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(isLoading){
that.$Loading.close()
}
console.log("error")
})
}else{
stockList({token: this.token, type: this.sort, lang: this.nation}).then(function(res){
var res = res.data;
if(isLoading){
that.$Loading.close()
}
that.coinList = res.data
}.bind(this),function(){
if(isLoading){
that.$Loading.close()
}
console.log("error")
})

stockLarge({token: this.token}).then(function(res){
var res = res.data;
if(isLoading){
that.$Loading.close()
}
that.stockList = res.data
}.bind(this),function(){
if(isLoading){
that.$Loading.close()
}
console.log("error")
})
}

},
sendMsg(content) {
this.msg = content;
this.show = true;
},
clearTimer() { //清楚定时器
clearInterval(this.timerInfo)
this.timerInfo = null
},


},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
watch: {
tabIndex: {
handler(curVal, oldVal) {
console.log(curVal)
if(curVal==0){
this.leftVal = (this.$refs.tab1.offsetWidth/2)-5+'px'
}else if(curVal == 1){
this.leftVal = this.$refs.tab1.offsetWidth-8+(this.$refs.tab2.offsetWidth/2)+'px'
}else if(curVal == 2){
this.leftVal = this.$refs.tab1.offsetWidth+16+((this.$refs.tab3.offsetWidth/2)+(this.$refs.tab2.offsetWidth/2))+'px'
}else if(curVal == 3){
this.leftVal = this.$refs.tab1.offsetWidth+16+((this.$refs.tab3.offsetWidth/2)+(this.$refs.tab2.offsetWidth/2)+(this.$refs.tab4.offsetWidth))+'px'
}else if(curVal == 4){
this.leftVal = this.$refs.tab1.offsetWidth+16+((this.$refs.tab3.offsetWidth/2)+(this.$refs.tab2.offsetWidth/2)+(this.$refs.tab4.offsetWidth)+(this.$refs.tab5.offsetWidth))+'px'
}else if(curVal == 5){

this.leftVal = this.$refs.tab1.offsetWidth+16+((this.$refs.tab3.offsetWidth/2)+(this.$refs.tab2.offsetWidth/2)+(this.$refs.tab4.offsetWidth)+(this.$refs.tab6.offsetWidth))+'px'
}
window.localStorage.setItem('tabIndex',this.tabIndex)
this.getCoinList(true)

},
deep: true
},
nation: {
handler(curVal, oldVal) {
this.getCoinList(true)

},
deep: true
},
sort: {
handler(curVal, oldVal) {
this.getCoinList(true)
},
deep: true
},
token:{
handler(curVal,oldVal){
console.log(111)
console.log(curVal)
console.log(oldVal)
if(curVal!=oldVal){
this.getBanner()
clearInterval(this.timerInfo)
this.timerInfo = null
this.getCoinList(true)
this.timerInfo = setInterval(() => {
if(this.coinList.length>0){
this.getCoinList()
}

}, 2000);
this.getNotice()
}
},
deep: true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/index.vue